import React from 'react'
import numeral from 'numeral'

import { useStyles } from './styles'
import { ViewerBreakdown } from 'redux/slices/viewer'

interface ViewerByCountryListProps {
    data: ViewerBreakdown
}

const ViewerByCountryList: React.FC<ViewerByCountryListProps> = ({ data }) => {
    const classes = useStyles()
    return (
        <ol className={classes.list}>
            {data.map((item, index) => (
                <li className={classes.item} key={item.country.name}>
                    <span className={classes.value}>
                        {index + 1}. <span className={classes.flag}>{item.country.emoji}</span>{' '}
                        <span className={classes.country}>{item.country.name}</span>
                    </span>
                    <span>{numeral(item.viewerCount).format(',')}</span>
                </li>
            ))}
        </ol>
    )
}

export default React.memo(ViewerByCountryList)
